<div class="card">
  <p class="title">Qual o tipo de pesquisa você quer criar?</p>

  <div class="card-list">
    <div class="card-box" (click)="selectType(pollTypeEnum.Satisfaction)">
      <div class="card-box__content">
        <p class="card-box__title">
          <span>Pesquisa de </span>
          <span>satisfação</span>
        </p>
      </div>
      <div class="card-box__image-container">
        <img src="assets/img/nps.png" alt="Ícone de satisfação" class="card-box__image"/>
      </div>
    </div>

    <div class="card-box card-box--last" (click)="selectType(pollTypeEnum.Reservation)">
      <div class="card-box__content">
        <p class="card-box__title">
          <span>Pesquisa de</span>
          <span>reserva de pratos</span>
        </p>
      </div>
      <div class="card-box__image-container">
        <img src="assets/img/reservation.png" alt="Ícone de reserva de pratos" class="card-box__image"/>
      </div>
    </div>
  </div>
</div>
